export const TEMPLATE_OPTIONS = {
	...require("../TEMPLATE_OPTIONS.json"),
};

export const name = {
	//provide your firstname and surname
	firstName: `John`,
	surname: `Anthony`,
};

export const about = {
	//provide a tagline describing you and a brief summary about yourself
	tagine: "UI/UX Designer", //appears on the sidebar
	shortDescription: `UI/UX Designer & Web Developer from Boston`,
	longDescription: `Pellentesque in ipsum id orci porta dapibus. Pellentesque in ipsum id orci porta dapibus. Quisque velit nisi, pretium ut lacinia in, elementum id enim. Mauris blandit aliquet elit, eget tincidunt nibh pulvinar a.`,
};

export const contactInfo = {
	// provide your contact info
	phone: "+1-848-448-1857", //your phone number
	email: "mail@yourdomain.com", //your email address
	address: `4929 Oak Avenue Wayne, NJ 07477`, //your address
};

//copyright text to be displayed on the sidebar
export const copyrightText = `Copyright 2021, Vectlab`;

export const pagination = {
	// maximum number of items to display per page on the blog and portfolio pages
	itemsPerPage: 6,
};

export const socialMedia = {
	// provide your handle for social media icons on the homepage
	twitter: "vectlab", //your twitter handle note: delete this line to hide twitter icon on the homepage
	facebook: "vectlab", //your facebook handle note: delete this line to hide twitter icon on the homepage
	github: "vectlab", //your github repo handle note: delete this line to hide twitter icon on the homepage
	instagram: "vectlab", //your instagram handle note: delete this line to hide twitter icon on the homepage
	behance: "vectlab", //your behance handle note: delete this line to hide twitter icon on the homepage
	dribbble: "vectlab", //your dribbble handle note: delete this line to hide twitter icon on the homepage
};

export const contactForm = {
	//provide your emailJs details below. visit https://www.emailjs.com/docs/ for more info
	YOUR_SERVICE_ID: `contact_service`, //provide emailJs your 'YOUR_SERVICE_ID' from your emailJs dashboard
	YOUR_TEMPLATE_ID: `contact_form`, //provide emailJs your 'YOUR_TEMPLATE_ID' from your emailJs dashboard
	YOUR_USER_ID: `user_19t5D9vVrGZ2BqNr6jMGq`, //provide emailJs your 'YOUR_USER_ID' from your emailJs dashboard
};

export const skills = [
	//provide as many skills as you want, each skill should be an object that has 'title' and 'percentage' attributes inside this array
	{
		title: "HTML/CSS",
		percentage: 80,
	},
	{
		title: "Javascript",
		percentage: 50,
	},
	{
		title: "Figma",
		percentage: 90,
	},
	{
		title: "Photoshop",
		percentage: 60,
	},
	{
		title: "Illustrator",
		percentage: 70,
	},
	{
		title: "React",
		percentage: 80,
	},
	{
		title: "WordPress",
		percentage: 50,
	},
	{
		title: "Adobe Xd",
		percentage: 90,
	},
];

export const reviews = [
	//provide as many reviews as you want, each review should be an object that has 'name', 'position' and 'review' attributes inside this array
	{
		name: "marrissa",
		position: "apple.co",
		review: `Donec sollicitudin molestie malesuada. Lorem ipsum dolor sit amet, consectetur adipiscing`,
	},
	{
		name: "john",
		position: "facebook Inc",
		review: `Donec sollicitudin molestie malesuada. Lorem ipsum dolor sit amet, consectetur adipiscing`,
	},
	{
		name: "mike",
		position: "UI/UX designer",
		review: `Donec sollicitudin molestie malesuada. Lorem ipsum dolor sit amet, consectetur adipiscing`,
	},
	{
		name: "lester",
		position: "data analyst",
		review: `Donec sollicitudin molestie malesuada. Lorem ipsum dolor sit amet, consectetur adipiscing`,
	},
	{
		name: "marrissa",
		position: "apple.co",
		review: `Donec sollicitudin molestie malesuada. Lorem ipsum dolor sit amet, consectetur adipiscing`,
	},
	{
		name: "john",
		position: "facebook Inc",
		review: `Donec sollicitudin molestie malesuada. Lorem ipsum dolor sit amet, consectetur adipiscing`,
	},
	{
		name: "mike",
		position: "UI/UX designer",
		review: `Donec sollicitudin molestie malesuada. Lorem ipsum dolor sit amet, consectetur adipiscing`,
	},
	{
		name: "lester",
		position: "data analyst",
		review: `Donec sollicitudin molestie malesuada. Lorem ipsum dolor sit amet, consectetur adipiscing`,
	},
];

// provide your disqus shortname for disqus comment integration visit https://help.disqus.com/en/articles/1717111-what-s-a-shortname for more info
export const disqusShortname = `boston-4`;

export const portfolios = [
	//provide as many portfolios as you want, each portfolio should be an object that has 'title', 'description'  and 'link' attributes inside this array
	//place all images to be used for the portfolios in the public/images/portfolios folder. make sure the images are named numerically e.g 1.jpg, 2.jpg
	{
		title: "Coffee Mug Mockup",
		description: `Pellentesque in ipsum id orci porta dapibus. Sed porttitor lectus nibh. Nulla porttitor accumsan tincidunt. Nulla porttitor accumsan tincidunt.

Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; Donec velit neque, auctor sit amet aliquam vel, ullamcorper sit amet lig Nulla quis lorem ut libero malesuada feugiat. Vivamus magna justo, lacinia eget consectetur sed, convallis at tellus.`,
		link: "http://www.itemlink/item",
	},
	{
		title: "Web Design",
		description: `Pellentesque in ipsum id orci porta dapibus. Sed porttitor lectus nibh. Nulla porttitor accumsan tincidunt. Nulla porttitor accumsan tincidunt.

Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; Donec velit neque, auctor sit amet aliquam vel, ullamcorper sit amet lig Nulla quis lorem ut libero malesuada feugiat. Vivamus magna justo, lacinia eget consectetur sed, convallis at tellus.`,
		link: "http://www.itemlink/item",
	},
	{
		title: "Portfolio page design",
		description: `Pellentesque in ipsum id orci porta dapibus. Sed porttitor lectus nibh. Nulla porttitor accumsan tincidunt. Nulla porttitor accumsan tincidunt.

Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; Donec velit neque, auctor sit amet aliquam vel, ullamcorper sit amet lig Nulla quis lorem ut libero malesuada feugiat. Vivamus magna justo, lacinia eget consectetur sed, convallis at tellus.`,
		link: "http://www.itemlink/item",
	},
	{
		title: "Mockup Design",
		description: `Pellentesque in ipsum id orci porta dapibus. Sed porttitor lectus nibh. Nulla porttitor accumsan tincidunt. Nulla porttitor accumsan tincidunt.

Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; Donec velit neque, auctor sit amet aliquam vel, ullamcorper sit amet lig Nulla quis lorem ut libero malesuada feugiat. Vivamus magna justo, lacinia eget consectetur sed, convallis at tellus.`,
		link: "http://www.itemlink/item",
	},
	{
		title: "Newslater cover design",
		description: `Pellentesque in ipsum id orci porta dapibus. Sed porttitor lectus nibh. Nulla porttitor accumsan tincidunt. Nulla porttitor accumsan tincidunt.

Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; Donec velit neque, auctor sit amet aliquam vel, ullamcorper sit amet lig Nulla quis lorem ut libero malesuada feugiat. Vivamus magna justo, lacinia eget consectetur sed, convallis at tellus.`,
		link: "http://www.itemlink/item",
	},
	{
		title: "Web Design",
		description: `Pellentesque in ipsum id orci porta dapibus. Sed porttitor lectus nibh. Nulla porttitor accumsan tincidunt. Nulla porttitor accumsan tincidunt.

Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; Donec velit neque, auctor sit amet aliquam vel, ullamcorper sit amet lig Nulla quis lorem ut libero malesuada feugiat. Vivamus magna justo, lacinia eget consectetur sed, convallis at tellus.`,
		link: "http://www.itemlink/item",
	},
	{
		title: "Coffee Mug Mockup",
		description: `Pellentesque in ipsum id orci porta dapibus. Sed porttitor lectus nibh. Nulla porttitor accumsan tincidunt. Nulla porttitor accumsan tincidunt.

Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; Donec velit neque, auctor sit amet aliquam vel, ullamcorper sit amet lig Nulla quis lorem ut libero malesuada feugiat. Vivamus magna justo, lacinia eget consectetur sed, convallis at tellus.`,
		link: "http://www.itemlink/item",
	},
	{
		title: "Coffee Mug Mockup 8",
		description: `Pellentesque in ipsum id orci porta dapibus. Sed porttitor lectus nibh. Nulla porttitor accumsan tincidunt. Nulla porttitor accumsan tincidunt.

Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; Donec velit neque, auctor sit amet aliquam vel, ullamcorper sit amet lig Nulla quis lorem ut libero malesuada feugiat. Vivamus magna justo, lacinia eget consectetur sed, convallis at tellus.`,
		link: "http://www.itemlink/item",
	},
	{
		title: "Business Card",
		description: `Pellentesque in ipsum id orci porta dapibus. Sed porttitor lectus nibh. Nulla porttitor accumsan tincidunt. Nulla porttitor accumsan tincidunt.

Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; Donec velit neque, auctor sit amet aliquam vel, ullamcorper sit amet lig Nulla quis lorem ut libero malesuada feugiat. Vivamus magna justo, lacinia eget consectetur sed, convallis at tellus.`,
		link: "http://www.itemlink/item",
	},
];

export const resume = [
	//provide your resume info here, provide as many resume objects as you want, each resume should have 'title', 'date', 'type' (work or academic) and description attributes
	{
		title: `Honors degree`,
		date: `2020-2012`,
		type: `academic`, //'work' or 'academic'
		description: `Quisque velit nisi, pretium ut lacinia in, elementum id enim. Donec rutrum congue leo eget malesuada. Vivamus magna justo, lacinia eget consectetur sed, convallis at tellus. Nulla quis lorem ut libero malesuada feugiat.`,
	},
	{
		title: `Masters degree`,
		date: `2012-2014`,
		type: `academic`, //'work' or 'academic'
		description: `Quisque velit nisi, pretium ut lacinia in, elementum id enim. Donec rutrum congue leo eget malesuada. Vivamus magna justo, lacinia eget consectetur sed, convallis at tellus. Nulla quis lorem ut libero malesuada feugiat.`,
	},
	{
		title: `Web Dev internship`,
		date: `2014-2016`,
		type: `academic`, //'work' or 'academic'
		description: `Quisque velit nisi, pretium ut lacinia in, elementum id enim. Donec rutrum congue leo eget malesuada. Vivamus magna justo, lacinia eget consectetur sed, convallis at tellus. Nulla quis lorem ut libero malesuada feugiat.`,
	},
	{
		title: `Head engineer at Compani co.`,
		date: `2016-2018`,
		type: `work`, //'work' or 'academic'
		description: `Quisque velit nisi, pretium ut lacinia in, elementum id enim. Donec rutrum congue leo eget malesuada. Vivamus magna justo, lacinia eget consectetur sed, convallis at tellus. Nulla quis lorem ut libero malesuada feugiat.`,
	},
	{
		title: `CTO at Apple`,
		date: `2018-2019`,
		type: `work`, //'work' or 'academic'
		description: `Quisque velit nisi, pretium ut lacinia in, elementum id enim. Donec rutrum congue leo eget malesuada. Vivamus magna justo, lacinia eget consectetur sed, convallis at tellus. Nulla quis lorem ut libero malesuada feugiat.`,
	},
	{
		title: `Senior Dev at Google`,
		date: `2019-2021`,
		type: `work`, //'work' or 'academic'
		description: `Quisque velit nisi, pretium ut lacinia in, elementum id enim. Donec rutrum congue leo eget malesuada. Vivamus magna justo, lacinia eget consectetur sed, convallis at tellus. Nulla quis lorem ut libero malesuada feugiat.`,
	},
];
